import React from 'react';
import { 
    Drawer,
    List,
    Spin,
    Input,
    message,
    Popconfirm,
    Button,
    Row
} from 'antd';


import {
    _postSearchAllSuppliers,
    _postChangeSupplierForOrder,
    _postChangeSupplierForProduct
} from '../../services'

import InfiniteScroll from 'react-infinite-scroller'
import { ADMIN_URL } from '../..';

import debounce from 'debounce'

const { Search } = Input

class ChangeSupplierDrawer extends React.Component{
	render(){

		return (
            <Drawer
                title="Change Supplier"
                visible={this.props.visible}
                onClose={this.props.closeDrawer}
            >
                {/* <Button onClick={()=>console.log(this.props.productIds)}>test</Button> */}
                <Search
                    placeholder="Search supplier name"
                    onChange={this.handleOnSearchChange}
                    onSearch={this.handleSearch}
                    style={{width:200, marginBottom:8}}
                    />
                <div  
                    style={{
                            border: "1px solid #e8e8e8",
                            borderRadius: 4,
                            padding: "8px 24px",
                            height:400,
                            overflow:"auto",
                            marginBottom:32
                        }}>
                    <InfiniteScroll
                            initialLoad={false}
                            loadMore={this.handleInfiniteOnLoad}
                            hasMore={!this.state.loading && this.state.hasMore}
                            useWindow={false}
                            >
                            <List
                                
                                dataSource={this.state.data}
                                renderItem={item => (
                                <Popconfirm
                                    title={`Change supplier to ${item.details.companyName}?`}
                                    onConfirm={!this.props.forProduct?
                                        ()=>this.handleChangeSupplier(item._id)
                                        :
                                        ()=>this.handleChangeSupplierForProduct(this.props.productId, item._id, this.props.enquiryId)
                                    }
                                    >
                                    <List.Item 
                                    style={{cursor:'pointer'}}
                                    key={item._id}>
                                        <List.Item.Meta
                                        title={item.details.companyName}
                                        description={item.local.email}
                                        />
                                    </List.Item>
                                </Popconfirm>
                                )}
                            >
                                {this.state.loading && this.state.hasMore && (
                                <div>
                                    <Spin />
                                </div>
                                )}
                            </List>
                    </InfiniteScroll>
                </div>
                <Row type="flex" justify="center">
                    <Button target="_blank" href={`${ADMIN_URL}/supplier`}>Create Supplier</Button>
                </Row>
            </Drawer>
		)
	}

	constructor(props){
        super(props);
        
        this.state = {
            data:[],
            loading:false,
            hasMore:true,
            page:1,
            searchTerm:false
        }
        
        this.handleSearch = debounce(this.handleSearch, 200);

    }

    
    componentWillMount(){
        
        _postSearchAllSuppliers({page:this.state.page})
        .then( res => this.setState({data:res.data.suppliers}))
        .catch( err => console.log(err))

    }

    handleChangeSupplier = (supplierId) =>{

        const { productIds, orderId } = this.props

        _postChangeSupplierForOrder({cartId: orderId, productIds, supplierId})
        .then(res => {

            const { cart, suppliersDetails } = res.data

            this.props.onChangeSupplier( cart );

            message.success("Supplier changed!");
            
        })
        .catch(err => message.error("Error!"))

    }

    handleChangeSupplierForProduct = (productId, supplierId, enquiryId) =>{

        message.loading("Changing supplier...")
    
        _postChangeSupplierForProduct({productId, supplierId, enquiryId})
        .then( res => {
            message.destroy()
            message.success("Successfully changed supplier!")
            this.props.getOpenEnquiries()
            this.props.closeDrawer()
        })
    
    }

    handleOnSearchChange = (e) => {

        if(!e){
            return
        } else {
            this.handleSearch(e.target.value)
        }
    }

    handleSearch = (value)=>{

        this.setState({
            page: 1,
            searchTerm: value,
            loading:true,
            hasMore:true
        }, ()=>{
            _postSearchAllSuppliers({page:this.state.page, searchTerm:this.state.searchTerm})
            .then( res => {
                if(res.data.suppliers.length === 0){
                    message.warning("No suppliers found!")
                }
                this.setState({data: res.data.suppliers, loading:false})
            })
        })
    }
    

    handleInfiniteOnLoad = () => {

        let { data, page, searchTerm } = this.state
    
        page += 1

        this.setState({
          loading: true,
          page
        });

        _postSearchAllSuppliers({page, searchTerm})
        .then(res => {

            if(res.data.suppliers.length === 0){
                message.warning("Loaded all suppliers")
                this.setState({
                    hasMore:false,
                    loading:false
                })
            } else {
                
                data = data.concat(res.data.suppliers)
                this.setState({
                    data,
                    loading:false
                })
            }

        })
      };

    
}

export default ChangeSupplierDrawer;


// WEBPACK FOOTER //
// ./src/components/orders-v2/change-supplier-drawer.js